import './utils/axios';
import './utils/helpers';

import { createApp } from 'vue';
import FloatingVue from 'floating-vue';
import Wysiwyg from './components/wysiwyg.vue';
import Hider from "./components/hider.vue";
import Alert from "./components/alert.vue";
import Modal from "./components/modal.vue";
import VueGoogleMaps from '@fawmi/vue-google-maps'
import DateRange from "./components/date-range.vue";
import DateFormat from "./components/date-format.vue";
import AddressAutoFill from "./components/address-auto-fill.vue";
import GenericMultiSelect from "./components/generic-multi-select.vue";
import NdisDateRanges from "./components/ndis-date-ranges.vue";
import DuplicateCheck from "./components/duplicate-check.vue";


const app = createApp({
    name: 'App',
    el: '#app',
    components: {
        'modal': Modal,
        'alert': Alert,
        'hider': Hider,
        'wysiwyg': Wysiwyg,
        'date-range': DateRange,
        'date-format': DateFormat,
        'address-auto-fill': AddressAutoFill,
        'generic-multi-select': GenericMultiSelect,
        'ndis-date-ranges': NdisDateRanges,
        'duplicate-check': DuplicateCheck,
    },
    data() {
        return {
            nav: false,
            enrolTotal: "$0.00",
        };
    },
    methods: {
        updateEnrolTotal() {
            this.enrolTotal = 0;

            for (let el of document.getElementsByClassName('js-enrol-total')) {
                if (el.checked) {
                    this.enrolTotal += parseFloat(el.dataset.price);
                }
            }

            this.enrolTotal = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' })
                .format(this.enrolTotal / 100);
        },
    },
});

app.use(FloatingVue)
    .use(VueGoogleMaps, {
        load: {
            key: window.bttb.google_maps,
            libraries: "places"
        }
    })
    .mount('#app');
